// Landing page data for sponsor solutions (Zeendoc, DocuWare, Yooz, NeoLedge)
// Each solution has multilingual content (FR, ES, EN)

export const landingData = {
  zeendoc: {
    id: "zeendoc",
    color: "#1a56db",
    logo: "https://customer-assets.emergentagent.com/job_4f3dc9ba-8fc8-4fff-96ff-60223c7a8223/artifacts/cskigm18_2f90b336-437c-4703-9aaa-a858df680c7a.png",
    website: "https://www.zeendoc.com",
    youtube: "https://www.youtube.com/embed/7x-h-h3u8Lw",
    country: { code: "FR", name: { fr: "France", es: "Francia", en: "France" } },
    hero: {
      fr: {
        title: "Zeendoc - La GED simple et efficace pour les PME",
        subtitle: "Dématérialisez vos documents, automatisez vos processus et gagnez en productivité avec Zeendoc.",
        cta: "Demander une démo gratuite"
      },
      es: {
        title: "Zeendoc - El DMS simple y eficiente para PYMEs",
        subtitle: "Digitalice sus documentos, automatice sus procesos y aumente la productividad con Zeendoc.",
        cta: "Solicitar demo gratuita"
      },
      en: {
        title: "Zeendoc - Simple & Efficient DMS for SMEs",
        subtitle: "Digitize your documents, automate your processes and boost productivity with Zeendoc.",
        cta: "Request a free demo"
      }
    },
    benefits: {
      fr: {
        title: "Pourquoi choisir Zeendoc ?",
        items: [
          { icon: "zap", title: "Déploiement rapide", desc: "Solution 100% Cloud, opérationnelle en quelques jours sans infrastructure lourde." },
          { icon: "search", title: "OCR intelligent", desc: "Reconnaissance automatique des documents et extraction des données clés." },
          { icon: "shield", title: "Conformité garantie", desc: "Archivage légal certifié NF Z42-013, RGPD et facture électronique." },
          { icon: "coins", title: "ROI immédiat", desc: "Réduction de 70% du temps de traitement documentaire dès le premier mois." },
          { icon: "users", title: "Interface intuitive", desc: "Prise en main facile pour tous les collaborateurs, sans formation longue." },
          { icon: "link", title: "Intégrations ERP", desc: "Compatible avec Sage, Cegid, EBP et les principaux outils comptables." }
        ]
      },
      es: {
        title: "¿Por qué elegir Zeendoc?",
        items: [
          { icon: "zap", title: "Despliegue rápido", desc: "Solución 100% Cloud, operativa en pocos días sin infraestructura pesada." },
          { icon: "search", title: "OCR inteligente", desc: "Reconocimiento automático de documentos y extracción de datos clave." },
          { icon: "shield", title: "Conformidad garantizada", desc: "Archivo legal certificado, cumplimiento RGPD y factura electrónica." },
          { icon: "coins", title: "ROI inmediato", desc: "Reducción del 70% del tiempo de procesamiento documental desde el primer mes." },
          { icon: "users", title: "Interfaz intuitiva", desc: "Fácil de usar para todos los colaboradores, sin formación prolongada." },
          { icon: "link", title: "Integraciones ERP", desc: "Compatible con Sage, Cegid, EBP y las principales herramientas contables." }
        ]
      },
      en: {
        title: "Why choose Zeendoc?",
        items: [
          { icon: "zap", title: "Fast deployment", desc: "100% Cloud solution, operational within days without heavy infrastructure." },
          { icon: "search", title: "Smart OCR", desc: "Automatic document recognition and key data extraction." },
          { icon: "shield", title: "Guaranteed compliance", desc: "Certified legal archiving, GDPR compliance and e-invoicing." },
          { icon: "coins", title: "Immediate ROI", desc: "70% reduction in document processing time from the first month." },
          { icon: "users", title: "Intuitive interface", desc: "Easy to use for all employees, no lengthy training required." },
          { icon: "link", title: "ERP integrations", desc: "Compatible with Sage, Cegid, EBP and major accounting tools." }
        ]
      }
    },
    useCases: {
      fr: {
        title: "Cas d'usage",
        items: [
          { title: "Comptabilité", desc: "Automatisez la saisie des factures fournisseurs et le rapprochement bancaire." },
          { title: "Ressources Humaines", desc: "Gérez les bulletins de paie, contrats et dossiers collaborateurs en toute sécurité." },
          { title: "Direction Générale", desc: "Accédez à tous vos documents stratégiques depuis n'importe quel appareil." }
        ]
      },
      es: {
        title: "Casos de uso",
        items: [
          { title: "Contabilidad", desc: "Automatice la entrada de facturas de proveedores y la conciliación bancaria." },
          { title: "Recursos Humanos", desc: "Gestione nóminas, contratos y expedientes de empleados de forma segura." },
          { title: "Dirección General", desc: "Acceda a todos sus documentos estratégicos desde cualquier dispositivo." }
        ]
      },
      en: {
        title: "Use cases",
        items: [
          { title: "Accounting", desc: "Automate supplier invoice entry and bank reconciliation." },
          { title: "Human Resources", desc: "Manage payslips, contracts and employee files securely." },
          { title: "Executive Management", desc: "Access all your strategic documents from any device." }
        ]
      }
    },
    roi: {
      fr: { title: "Retour sur investissement", items: [
        { value: "70%", label: "Réduction du temps de traitement" },
        { value: "3x", label: "Plus rapide que le classement papier" },
        { value: "€15K", label: "Économies moyennes/an" },
        { value: "99.9%", label: "Disponibilité Cloud" }
      ]},
      es: { title: "Retorno de inversión", items: [
        { value: "70%", label: "Reducción del tiempo de procesamiento" },
        { value: "3x", label: "Más rápido que el archivo en papel" },
        { value: "€15K", label: "Ahorro medio/año" },
        { value: "99.9%", label: "Disponibilidad Cloud" }
      ]},
      en: { title: "Return on investment", items: [
        { value: "70%", label: "Processing time reduction" },
        { value: "3x", label: "Faster than paper filing" },
        { value: "€15K", label: "Average savings/year" },
        { value: "99.9%", label: "Cloud availability" }
      ]}
    }
  },

  docuware: {
    id: "docuware",
    color: "#0066cc",
    logo: "https://customer-assets.emergentagent.com/job_4f3dc9ba-8fc8-4fff-96ff-60223c7a8223/artifacts/yrn5at9h_logo%20docuware.GIF",
    website: "https://www.docuware.com",
    youtube: "https://www.youtube.com/embed/tUVW3_kprBo",
    country: { code: "DE", name: { fr: "Allemagne", es: "Alemania", en: "Germany" } },
    hero: {
      fr: {
        title: "DocuWare - L'automatisation documentaire pour les grandes entreprises",
        subtitle: "Automatisez vos workflows, gérez vos documents et digitalisez vos processus métier avec DocuWare.",
        cta: "Demander une démo gratuite"
      },
      es: {
        title: "DocuWare - Automatización documental para grandes empresas",
        subtitle: "Automatice sus flujos de trabajo, gestione sus documentos y digitalice sus procesos con DocuWare.",
        cta: "Solicitar demo gratuita"
      },
      en: {
        title: "DocuWare - Document Automation for Large Enterprises",
        subtitle: "Automate your workflows, manage your documents and digitize your business processes with DocuWare.",
        cta: "Request a free demo"
      }
    },
    benefits: {
      fr: {
        title: "Pourquoi choisir DocuWare ?",
        items: [
          { icon: "workflow", title: "Workflows intelligents", desc: "Créez des flux de validation automatisés adaptés à votre organisation." },
          { icon: "globe", title: "Présence mondiale", desc: "Disponible dans plus de 24 langues avec support dans plus de 100 pays." },
          { icon: "lock", title: "Sécurité renforcée", desc: "Certifications ISO 27001, SOC 2 et conformité RGPD native." },
          { icon: "layers", title: "Déploiement flexible", desc: "Cloud, on-premise ou hybride selon vos besoins d'infrastructure." },
          { icon: "search", title: "Recherche avancée", desc: "Trouvez n'importe quel document en secondes grâce à l'indexation intelligente." },
          { icon: "link", title: "Intégrations natives", desc: "Connectez-vous à SAP, Microsoft 365, Salesforce et plus de 500 applications." }
        ]
      },
      es: {
        title: "¿Por qué elegir DocuWare?",
        items: [
          { icon: "workflow", title: "Workflows inteligentes", desc: "Cree flujos de validación automatizados adaptados a su organización." },
          { icon: "globe", title: "Presencia mundial", desc: "Disponible en más de 24 idiomas con soporte en más de 100 países." },
          { icon: "lock", title: "Seguridad reforzada", desc: "Certificaciones ISO 27001, SOC 2 y cumplimiento RGPD nativo." },
          { icon: "layers", title: "Despliegue flexible", desc: "Cloud, on-premise o híbrido según sus necesidades de infraestructura." },
          { icon: "search", title: "Búsqueda avanzada", desc: "Encuentre cualquier documento en segundos gracias a la indexación inteligente." },
          { icon: "link", title: "Integraciones nativas", desc: "Conéctese a SAP, Microsoft 365, Salesforce y más de 500 aplicaciones." }
        ]
      },
      en: {
        title: "Why choose DocuWare?",
        items: [
          { icon: "workflow", title: "Smart workflows", desc: "Create automated approval workflows tailored to your organization." },
          { icon: "globe", title: "Global presence", desc: "Available in 24+ languages with support in 100+ countries." },
          { icon: "lock", title: "Enhanced security", desc: "ISO 27001, SOC 2 certifications and native GDPR compliance." },
          { icon: "layers", title: "Flexible deployment", desc: "Cloud, on-premise or hybrid to suit your infrastructure needs." },
          { icon: "search", title: "Advanced search", desc: "Find any document in seconds with intelligent indexing." },
          { icon: "link", title: "Native integrations", desc: "Connect to SAP, Microsoft 365, Salesforce and 500+ apps." }
        ]
      }
    },
    useCases: {
      fr: {
        title: "Cas d'usage",
        items: [
          { title: "Finance & Comptabilité", desc: "Automatisez le traitement des factures et les approbations de dépenses." },
          { title: "Logistique & Supply Chain", desc: "Digitalisez les bons de livraison, factures et documents de transport." },
          { title: "Administration & Juridique", desc: "Centralisez les contrats, polices d'assurance et documents réglementaires." }
        ]
      },
      es: {
        title: "Casos de uso",
        items: [
          { title: "Finanzas y Contabilidad", desc: "Automatice el procesamiento de facturas y las aprobaciones de gastos." },
          { title: "Logística y Cadena de suministro", desc: "Digitalice albaranes, facturas y documentos de transporte." },
          { title: "Administración y Legal", desc: "Centralice contratos, pólizas de seguro y documentos regulatorios." }
        ]
      },
      en: {
        title: "Use cases",
        items: [
          { title: "Finance & Accounting", desc: "Automate invoice processing and expense approvals." },
          { title: "Logistics & Supply Chain", desc: "Digitize delivery notes, invoices and transport documents." },
          { title: "Administration & Legal", desc: "Centralize contracts, insurance policies and regulatory documents." }
        ]
      }
    },
    roi: {
      fr: { title: "Retour sur investissement", items: [
        { value: "80%", label: "Réduction des tâches manuelles" },
        { value: "50%", label: "Plus rapide pour les approbations" },
        { value: "€25K", label: "Économies moyennes/an" },
        { value: "100+", label: "Pays couverts" }
      ]},
      es: { title: "Retorno de inversión", items: [
        { value: "80%", label: "Reducción de tareas manuales" },
        { value: "50%", label: "Más rápido en aprobaciones" },
        { value: "€25K", label: "Ahorro medio/año" },
        { value: "100+", label: "Países cubiertos" }
      ]},
      en: { title: "Return on investment", items: [
        { value: "80%", label: "Manual task reduction" },
        { value: "50%", label: "Faster approvals" },
        { value: "€25K", label: "Average savings/year" },
        { value: "100+", label: "Countries covered" }
      ]}
    }
  },

  yooz: {
    id: "yooz",
    color: "#6366f1",
    logo: "https://customer-assets.emergentagent.com/job_5577aad2-a1d8-4595-9afc-d525b5b1b883/artifacts/6og8kqyj_Yooz-Logo-Full-Colors-Transparent%20%283%29.png",
    website: "https://www.getyooz.com",
    youtube: "https://www.youtube.com/embed/CiWY5NnDm3Y",
    country: { code: "FR", name: { fr: "France", es: "Francia", en: "France" } },
    hero: {
      fr: {
        title: "Yooz - L'automatisation des factures propulsée par l'IA",
        subtitle: "Automatisez 80% de vos factures fournisseurs avec l'IA et le RPA. Du Purchase-to-Pay en quelques clics.",
        cta: "Demander une démo gratuite"
      },
      es: {
        title: "Yooz - Automatización de facturas impulsada por IA",
        subtitle: "Automatice el 80% de sus facturas de proveedores con IA y RPA. Purchase-to-Pay en pocos clics.",
        cta: "Solicitar demo gratuita"
      },
      en: {
        title: "Yooz - AI-Powered Invoice Automation",
        subtitle: "Automate 80% of your supplier invoices with AI and RPA. Purchase-to-Pay in just a few clicks.",
        cta: "Request a free demo"
      }
    },
    benefits: {
      fr: {
        title: "Pourquoi choisir Yooz ?",
        items: [
          { icon: "brain", title: "IA de pointe", desc: "Reconnaissance et extraction automatique des données de facturation par deep learning." },
          { icon: "zap", title: "Automatisation P2P", desc: "Cycle Purchase-to-Pay complet : de la commande au paiement, tout est automatisé." },
          { icon: "check-circle", title: "Taux de capture 80%+", desc: "Plus de 80% des factures traitées automatiquement sans intervention humaine." },
          { icon: "link", title: "200+ connecteurs ERP", desc: "Intégration native avec Sage, SAP, Microsoft Dynamics, Cegid et plus." },
          { icon: "shield", title: "Conformité & Audit", desc: "Piste d'audit complète, archivage légal et conformité fiscale garantie." },
          { icon: "globe", title: "Solution multilingue", desc: "Interface et support disponibles en français, anglais, espagnol et plus." }
        ]
      },
      es: {
        title: "¿Por qué elegir Yooz?",
        items: [
          { icon: "brain", title: "IA de vanguardia", desc: "Reconocimiento y extracción automática de datos de facturación por deep learning." },
          { icon: "zap", title: "Automatización P2P", desc: "Ciclo Purchase-to-Pay completo: del pedido al pago, todo automatizado." },
          { icon: "check-circle", title: "Tasa de captura 80%+", desc: "Más del 80% de las facturas procesadas automáticamente sin intervención humana." },
          { icon: "link", title: "200+ conectores ERP", desc: "Integración nativa con Sage, SAP, Microsoft Dynamics, Cegid y más." },
          { icon: "shield", title: "Conformidad y Auditoría", desc: "Pista de auditoría completa, archivo legal y conformidad fiscal garantizada." },
          { icon: "globe", title: "Solución multilingüe", desc: "Interfaz y soporte disponibles en francés, inglés, español y más." }
        ]
      },
      en: {
        title: "Why choose Yooz?",
        items: [
          { icon: "brain", title: "Cutting-edge AI", desc: "Automatic recognition and extraction of invoice data using deep learning." },
          { icon: "zap", title: "P2P automation", desc: "Complete Purchase-to-Pay cycle: from order to payment, fully automated." },
          { icon: "check-circle", title: "80%+ capture rate", desc: "Over 80% of invoices processed automatically without human intervention." },
          { icon: "link", title: "200+ ERP connectors", desc: "Native integration with Sage, SAP, Microsoft Dynamics, Cegid and more." },
          { icon: "shield", title: "Compliance & Audit", desc: "Complete audit trail, legal archiving and guaranteed tax compliance." },
          { icon: "globe", title: "Multilingual solution", desc: "Interface and support available in French, English, Spanish and more." }
        ]
      }
    },
    useCases: {
      fr: {
        title: "Cas d'usage",
        items: [
          { title: "Dématérialisation factures", desc: "Capturez, classez et validez vos factures fournisseurs automatiquement." },
          { title: "Approbation & Workflows", desc: "Configurez des circuits de validation multi-niveaux adaptés à votre organisation." },
          { title: "Rapprochement automatique", desc: "Rapprochez automatiquement factures, bons de commande et bons de livraison." }
        ]
      },
      es: {
        title: "Casos de uso",
        items: [
          { title: "Digitalización de facturas", desc: "Capture, clasifique y valide sus facturas de proveedores automáticamente." },
          { title: "Aprobación y Workflows", desc: "Configure circuitos de validación multinivel adaptados a su organización." },
          { title: "Conciliación automática", desc: "Concilie automáticamente facturas, órdenes de compra y albaranes." }
        ]
      },
      en: {
        title: "Use cases",
        items: [
          { title: "Invoice digitization", desc: "Capture, classify and validate your supplier invoices automatically." },
          { title: "Approval & Workflows", desc: "Configure multi-level approval workflows tailored to your organization." },
          { title: "Automatic matching", desc: "Automatically match invoices, purchase orders and delivery notes." }
        ]
      }
    },
    roi: {
      fr: { title: "Retour sur investissement", items: [
        { value: "80%", label: "Factures traitées par l'IA" },
        { value: "5x", label: "Plus rapide que le traitement manuel" },
        { value: "€20K", label: "Économies moyennes/an" },
        { value: "200+", label: "Connecteurs ERP disponibles" }
      ]},
      es: { title: "Retorno de inversión", items: [
        { value: "80%", label: "Facturas procesadas por IA" },
        { value: "5x", label: "Más rápido que el procesamiento manual" },
        { value: "€20K", label: "Ahorro medio/año" },
        { value: "200+", label: "Conectores ERP disponibles" }
      ]},
      en: { title: "Return on investment", items: [
        { value: "80%", label: "Invoices processed by AI" },
        { value: "5x", label: "Faster than manual processing" },
        { value: "€20K", label: "Average savings/year" },
        { value: "200+", label: "ERP connectors available" }
      ]}
    }
  },

  neoledge: {
    id: "neoledge",
    color: "#059669",
    logo: "https://customer-assets.emergentagent.com/job_7fe777d6-9bad-4a97-9808-a97a60a006ea/artifacts/pcnw3uxp_logo%20neoledge%201.0.GIF",
    website: "https://www.neoledge.com",
    youtube: "https://www.youtube.com/embed/sBCLW42O0yg",
    country: { code: "TN", name: { fr: "Tunisie", es: "Túnez", en: "Tunisia" } },
    hero: {
      fr: {
        title: "NeoLedge - Gestion documentaire avancée et conformité",
        subtitle: "Solution GED complète pour les grandes entreprises avec des exigences élevées en sécurité et conformité réglementaire.",
        cta: "Demander une démo gratuite"
      },
      es: {
        title: "NeoLedge - Gestión documental avanzada y cumplimiento",
        subtitle: "Solución DMS completa para grandes empresas con altas exigencias de seguridad y cumplimiento normativo.",
        cta: "Solicitar demo gratuita"
      },
      en: {
        title: "NeoLedge - Advanced Document Management & Compliance",
        subtitle: "Complete DMS solution for large enterprises with high security and regulatory compliance requirements.",
        cta: "Request a free demo"
      }
    },
    benefits: {
      fr: {
        title: "Pourquoi choisir NeoLedge ?",
        items: [
          { icon: "shield", title: "Sécurité maximale", desc: "Chiffrement de bout en bout, contrôle d'accès granulaire et traçabilité complète." },
          { icon: "scale", title: "Conformité réglementaire", desc: "NF Z42-013, ISO 14641, eIDAS et conformité RGPD native." },
          { icon: "layers", title: "Architecture modulaire", desc: "Plateforme évolutive qui s'adapte à vos besoins croissants." },
          { icon: "workflow", title: "BPM intégré", desc: "Moteur de workflows puissant pour automatiser vos processus métier complexes." },
          { icon: "search", title: "Recherche plein texte", desc: "Moteur de recherche avancé avec OCR et classification automatique." },
          { icon: "database", title: "Archivage probant", desc: "Archivage à valeur probante certifié pour vos documents critiques." }
        ]
      },
      es: {
        title: "¿Por qué elegir NeoLedge?",
        items: [
          { icon: "shield", title: "Seguridad máxima", desc: "Cifrado de extremo a extremo, control de acceso granular y trazabilidad completa." },
          { icon: "scale", title: "Cumplimiento normativo", desc: "NF Z42-013, ISO 14641, eIDAS y cumplimiento RGPD nativo." },
          { icon: "layers", title: "Arquitectura modular", desc: "Plataforma escalable que se adapta a sus necesidades crecientes." },
          { icon: "workflow", title: "BPM integrado", desc: "Motor de workflows potente para automatizar sus procesos empresariales complejos." },
          { icon: "search", title: "Búsqueda de texto completo", desc: "Motor de búsqueda avanzado con OCR y clasificación automática." },
          { icon: "database", title: "Archivo probatorio", desc: "Archivo con valor probatorio certificado para sus documentos críticos." }
        ]
      },
      en: {
        title: "Why choose NeoLedge?",
        items: [
          { icon: "shield", title: "Maximum security", desc: "End-to-end encryption, granular access control and complete traceability." },
          { icon: "scale", title: "Regulatory compliance", desc: "NF Z42-013, ISO 14641, eIDAS and native GDPR compliance." },
          { icon: "layers", title: "Modular architecture", desc: "Scalable platform that adapts to your growing needs." },
          { icon: "workflow", title: "Built-in BPM", desc: "Powerful workflow engine to automate your complex business processes." },
          { icon: "search", title: "Full-text search", desc: "Advanced search engine with OCR and automatic classification." },
          { icon: "database", title: "Evidential archiving", desc: "Certified evidential archiving for your critical documents." }
        ]
      }
    },
    useCases: {
      fr: {
        title: "Cas d'usage",
        items: [
          { title: "Secteur public", desc: "Dématérialisation des processus administratifs et archivage réglementaire." },
          { title: "Banque & Assurance", desc: "Gestion sécurisée des dossiers clients, polices et documents contractuels." },
          { title: "Industrie & BTP", desc: "Gestion documentaire technique, plans, certifications et conformité qualité." }
        ]
      },
      es: {
        title: "Casos de uso",
        items: [
          { title: "Sector público", desc: "Digitalización de procesos administrativos y archivo regulatorio." },
          { title: "Banca y Seguros", desc: "Gestión segura de expedientes de clientes, pólizas y documentos contractuales." },
          { title: "Industria y Construcción", desc: "Gestión documental técnica, planos, certificaciones y conformidad de calidad." }
        ]
      },
      en: {
        title: "Use cases",
        items: [
          { title: "Public sector", desc: "Digitization of administrative processes and regulatory archiving." },
          { title: "Banking & Insurance", desc: "Secure management of client files, policies and contractual documents." },
          { title: "Industry & Construction", desc: "Technical document management, plans, certifications and quality compliance." }
        ]
      }
    },
    roi: {
      fr: { title: "Retour sur investissement", items: [
        { value: "90%", label: "Conformité réglementaire automatisée" },
        { value: "60%", label: "Réduction des coûts d'archivage" },
        { value: "€30K", label: "Économies moyennes/an" },
        { value: "99.99%", label: "Intégrité des données" }
      ]},
      es: { title: "Retorno de inversión", items: [
        { value: "90%", label: "Cumplimiento normativo automatizado" },
        { value: "60%", label: "Reducción de costos de archivo" },
        { value: "€30K", label: "Ahorro medio/año" },
        { value: "99.99%", label: "Integridad de datos" }
      ]},
      en: { title: "Return on investment", items: [
        { value: "90%", label: "Automated regulatory compliance" },
        { value: "60%", label: "Archiving cost reduction" },
        { value: "€30K", label: "Average savings/year" },
        { value: "99.99%", label: "Data integrity" }
      ]}
    }
  },

  twind: {
    id: "twind",
    color: "#0EA5E9",
    logo: "https://customer-assets.emergentagent.com/job_7fe777d6-9bad-4a97-9808-a97a60a006ea/artifacts/fjy58uyr_logo%20twind.GIF",
    website: "https://www.twind.io",
    youtube: "",
    country: { code: "FR", name: { fr: "France", es: "Francia", en: "France" } },
    hero: {
      fr: { title: "Twind - La GED collaborative nouvelle génération", subtitle: "Plateforme moderne de gestion documentaire avec IA native, workflows no-code et conformité RGPD.", cta: "Demander une démo gratuite" },
      es: { title: "Twind - El DMS colaborativo de nueva generación", subtitle: "Plataforma moderna de gestión documental con IA nativa, workflows no-code y cumplimiento RGPD.", cta: "Solicitar demo gratuita" },
      en: { title: "Twind - The next-generation collaborative DMS", subtitle: "Modern document management platform with native AI, no-code workflows and GDPR compliance.", cta: "Request a free demo" }
    },
    benefits: {
      fr: { title: "Pourquoi choisir Twind ?", items: [
        { icon: "brain", title: "IA native", desc: "Classification, OCR et extraction automatique des documents." },
        { icon: "workflow", title: "Workflows no-code", desc: "Créez vos processus métier sans écrire une ligne de code." },
        { icon: "users", title: "Collaboration temps réel", desc: "Partage, commentaires et annotations collaboratives." },
        { icon: "shield", title: "Conformité RGPD", desc: "Archivage sécurisé et traçabilité complète des accès." },
        { icon: "link", title: "API & intégrations", desc: "Connectez Twind à vos outils existants via API REST." },
        { icon: "globe", title: "Cloud européen", desc: "Hébergement en France, souveraineté des données." }
      ]},
      es: { title: "¿Por qué elegir Twind?", items: [
        { icon: "brain", title: "IA nativa", desc: "Clasificación, OCR y extracción automática de documentos." },
        { icon: "workflow", title: "Workflows no-code", desc: "Cree sus procesos empresariales sin escribir código." },
        { icon: "users", title: "Colaboración en tiempo real", desc: "Compartir, comentar y anotar de forma colaborativa." },
        { icon: "shield", title: "Conformidad RGPD", desc: "Archivo seguro y trazabilidad completa de accesos." },
        { icon: "link", title: "API e integraciones", desc: "Conecte Twind con sus herramientas vía API REST." },
        { icon: "globe", title: "Cloud europeo", desc: "Alojamiento en Europa, soberanía de datos." }
      ]},
      en: { title: "Why choose Twind?", items: [
        { icon: "brain", title: "Native AI", desc: "Classification, OCR and automatic document extraction." },
        { icon: "workflow", title: "No-code workflows", desc: "Build your business processes without writing any code." },
        { icon: "users", title: "Real-time collaboration", desc: "Share, comment and annotate collaboratively." },
        { icon: "shield", title: "GDPR compliance", desc: "Secure archiving and complete access traceability." },
        { icon: "link", title: "API & integrations", desc: "Connect Twind to your tools via REST API." },
        { icon: "globe", title: "European cloud", desc: "Hosted in Europe, full data sovereignty." }
      ]}
    },
    useCases: {
      fr: { title: "Cas d'usage", items: [
        { title: "GED collaborative", desc: "Centralisez vos documents et collaborez en temps réel." },
        { title: "Automatisation des workflows", desc: "Automatisez vos circuits de validation et signatures." },
        { title: "Archivage légal", desc: "Conservez vos documents avec valeur probante." }
      ]},
      es: { title: "Casos de uso", items: [
        { title: "DMS colaborativa", desc: "Centralice documentos y colabore en tiempo real." },
        { title: "Automatización de workflows", desc: "Automatice circuitos de validación y firmas." },
        { title: "Archivo legal", desc: "Conserve sus documentos con valor probatorio." }
      ]},
      en: { title: "Use cases", items: [
        { title: "Collaborative DMS", desc: "Centralize documents and collaborate in real time." },
        { title: "Workflow automation", desc: "Automate approval and signature circuits." },
        { title: "Legal archiving", desc: "Store documents with evidential value." }
      ]}
    },
    roi: {
      fr: { title: "Retour sur investissement", items: [
        { value: "-50%", label: "Temps de traitement documentaire" },
        { value: "+40%", label: "Productivité collaborative" },
        { value: "€15K", label: "Économies moyennes/an" },
        { value: "99.9%", label: "Disponibilité cloud" }
      ]},
      es: { title: "Retorno de inversión", items: [
        { value: "-50%", label: "Tiempo de procesamiento documental" },
        { value: "+40%", label: "Productividad colaborativa" },
        { value: "€15K", label: "Ahorro medio/año" },
        { value: "99.9%", label: "Disponibilidad cloud" }
      ]},
      en: { title: "Return on investment", items: [
        { value: "-50%", label: "Document processing time" },
        { value: "+40%", label: "Collaborative productivity" },
        { value: "€15K", label: "Average savings/year" },
        { value: "99.9%", label: "Cloud uptime" }
      ]}
    }
  },

  doxis: {
    id: "doxis", color: "#E91E90",
    logo: "https://customer-assets.emergentagent.com/job_7fe777d6-9bad-4a97-9808-a97a60a006ea/artifacts/kc9bmomj_logo%20doxis.GIF",
    website: "https://www.sergroup.com/", youtube: "",
    country: { code: "DE", name: { fr: "Allemagne", es: "Alemania", en: "Germany" } },
    hero: {
      fr: { title: "Doxis - Plateforme ECM intelligente by SER Group", subtitle: "Gestion documentaire d'entreprise, automatisation des processus et conformité réglementaire avec IA intégrée.", cta: "Demander une démo" },
      es: { title: "Doxis - Plataforma ECM inteligente by SER Group", subtitle: "Gestión documental empresarial, automatización de procesos y cumplimiento normativo con IA integrada.", cta: "Solicitar demo" },
      en: { title: "Doxis - Intelligent ECM platform by SER Group", subtitle: "Enterprise document management, process automation and regulatory compliance with built-in AI.", cta: "Request a demo" }
    },
    benefits: {
      fr: { title: "Pourquoi choisir Doxis ?", items: [
        { icon: "brain", title: "IA et classification", desc: "Catégorisation automatique et extraction intelligente." },
        { icon: "workflow", title: "Automatisation processus", desc: "Workflows BPM complets pour les processus métier." },
        { icon: "shield", title: "Conformité totale", desc: "RGPD, ISO 27001, archivage légal NF Z42-013." },
        { icon: "link", title: "Intégrations ERP", desc: "SAP, Microsoft 365, Salesforce, Oracle." },
        { icon: "users", title: "Collaboration", desc: "Espaces de travail partagés sécurisés." },
        { icon: "globe", title: "International", desc: "Multi-langue, multi-fuseaux, conformité par pays." }
      ]},
      es: { title: "¿Por qué elegir Doxis?", items: [
        { icon: "brain", title: "IA y clasificación", desc: "Categorización automática y extracción inteligente." },
        { icon: "workflow", title: "Automatización procesos", desc: "Workflows BPM completos para procesos empresariales." },
        { icon: "shield", title: "Cumplimiento total", desc: "RGPD, ISO 27001, archivado legal ISO 14641-1." },
        { icon: "link", title: "Integraciones ERP", desc: "SAP, Microsoft 365, Salesforce, Oracle." },
        { icon: "users", title: "Colaboración", desc: "Espacios de trabajo compartidos y seguros." },
        { icon: "globe", title: "Internacional", desc: "Multi-idioma, multi-zona, cumplimiento por país." }
      ]},
      en: { title: "Why choose Doxis?", items: [
        { icon: "brain", title: "AI & classification", desc: "Automatic categorization and intelligent extraction." },
        { icon: "workflow", title: "Process automation", desc: "Complete BPM workflows for business processes." },
        { icon: "shield", title: "Full compliance", desc: "GDPR, ISO 27001, legal archiving ISO 14641-1." },
        { icon: "link", title: "ERP integrations", desc: "SAP, Microsoft 365, Salesforce, Oracle." },
        { icon: "users", title: "Collaboration", desc: "Secure shared workspaces." },
        { icon: "globe", title: "International", desc: "Multi-language, multi-zone, per-country compliance." }
      ]}
    },
    useCases: {
      fr: { title: "Cas d'usage", items: [
        { title: "Gestion contrats", desc: "Cycle de vie contractuel complet avec workflows et signature électronique." },
        { title: "Comptes fournisseurs", desc: "Automatisation P2P avec OCR et matching ERP." },
        { title: "Conformité RH", desc: "Dossiers du personnel digitalisés et conformes RGPD." }
      ]},
      es: { title: "Casos de uso", items: [
        { title: "Gestión de contratos", desc: "Ciclo de vida contractual completo con workflows y firma electrónica." },
        { title: "Cuentas por pagar", desc: "Automatización P2P con OCR y matching ERP." },
        { title: "Cumplimiento RRHH", desc: "Expedientes de personal digitalizados y conformes RGPD." }
      ]},
      en: { title: "Use cases", items: [
        { title: "Contract management", desc: "Full contract lifecycle with workflows and e-signature." },
        { title: "Accounts payable", desc: "P2P automation with OCR and ERP matching." },
        { title: "HR compliance", desc: "Digital personnel files, GDPR-compliant." }
      ]}
    },
    roi: {
      fr: { title: "Retour sur investissement", items: [
        { value: "-60%", label: "Temps de traitement contrats" },
        { value: "+45%", label: "Productivité documentaire" },
        { value: "€30K", label: "Économies moyennes/an" },
        { value: "99.9%", label: "Disponibilité cloud" }
      ]},
      es: { title: "Retorno de inversión", items: [
        { value: "-60%", label: "Tiempo de gestión contratos" },
        { value: "+45%", label: "Productividad documental" },
        { value: "€30K", label: "Ahorro medio/año" },
        { value: "99.9%", label: "Disponibilidad cloud" }
      ]},
      en: { title: "Return on investment", items: [
        { value: "-60%", label: "Contract processing time" },
        { value: "+45%", label: "Document productivity" },
        { value: "€30K", label: "Average savings/year" },
        { value: "99.9%", label: "Cloud uptime" }
      ]}
    }
  },

  opentext: {
    id: "opentext", color: "#1A3567",
    logo: "https://customer-assets.emergentagent.com/job_7fe777d6-9bad-4a97-9808-a97a60a006ea/artifacts/v7iwc12m_open%20text%20logo%202.png",
    website: "https://www.opentext.com/", youtube: "",
    country: { code: "CA", name: { fr: "Canada", es: "Canadá", en: "Canada" } },
    hero: {
      fr: { title: "OpenText - Leader mondial de l'Information Management", subtitle: "Plateforme ECM complète pour les grandes organisations : IA, automatisation, conformité, capture intelligente.", cta: "Demander une démo" },
      es: { title: "OpenText - Líder mundial en Information Management", subtitle: "Plataforma ECM completa para grandes organizaciones: IA, automatización, cumplimiento, captura inteligente.", cta: "Solicitar demo" },
      en: { title: "OpenText - Global Information Management leader", subtitle: "Complete ECM platform for large organizations: AI, automation, compliance, intelligent capture.", cta: "Request a demo" }
    },
    benefits: {
      fr: { title: "Pourquoi OpenText ?", items: [
        { icon: "brain", title: "Magellan AI", desc: "Capture cognitive et analytics intégrés." },
        { icon: "workflow", title: "Process automation", desc: "RPA et orchestration des processus métier." },
        { icon: "shield", title: "Conformité globale", desc: "Records management, RGPD, HIPAA, SOX." },
        { icon: "link", title: "Intégrations natives", desc: "SAP, Microsoft, Salesforce, Oracle." },
        { icon: "globe", title: "Présence mondiale", desc: "+80 pays, multi-langues, support 24/7." },
        { icon: "users", title: "Grandes organisations", desc: "Conçu pour entreprises 1000+ utilisateurs." }
      ]},
      es: { title: "¿Por qué OpenText?", items: [
        { icon: "brain", title: "Magellan AI", desc: "Captura cognitiva y analítica integrada." },
        { icon: "workflow", title: "Process automation", desc: "RPA y orquestación de procesos empresariales." },
        { icon: "shield", title: "Cumplimiento global", desc: "Records management, RGPD, HIPAA, SOX." },
        { icon: "link", title: "Integraciones nativas", desc: "SAP, Microsoft, Salesforce, Oracle." },
        { icon: "globe", title: "Presencia global", desc: "+80 países, multi-idioma, soporte 24/7." },
        { icon: "users", title: "Grandes organizaciones", desc: "Diseñado para empresas de 1000+ usuarios." }
      ]},
      en: { title: "Why OpenText?", items: [
        { icon: "brain", title: "Magellan AI", desc: "Cognitive capture and embedded analytics." },
        { icon: "workflow", title: "Process automation", desc: "RPA and business process orchestration." },
        { icon: "shield", title: "Global compliance", desc: "Records management, GDPR, HIPAA, SOX." },
        { icon: "link", title: "Native integrations", desc: "SAP, Microsoft, Salesforce, Oracle." },
        { icon: "globe", title: "Worldwide footprint", desc: "+80 countries, multi-language, 24/7 support." },
        { icon: "users", title: "Large organizations", desc: "Built for 1000+ user enterprises." }
      ]}
    },
    useCases: {
      fr: { title: "Cas d'usage", items: [
        { title: "Information Governance", desc: "Pilotage de l'information à l'échelle de l'entreprise." },
        { title: "Customer Experience Management", desc: "Personnalisation des parcours documentaires clients." },
        { title: "Cloud Editions OT2", desc: "Migration cloud des workloads ECM critiques." }
      ]},
      es: { title: "Casos de uso", items: [
        { title: "Gobernanza de la información", desc: "Gestión de la información a escala empresarial." },
        { title: "Customer Experience Management", desc: "Personalización de recorridos documentales de cliente." },
        { title: "Cloud Editions OT2", desc: "Migración cloud de cargas ECM críticas." }
      ]},
      en: { title: "Use cases", items: [
        { title: "Information Governance", desc: "Enterprise-wide information stewardship." },
        { title: "Customer Experience Management", desc: "Personalizing customer document journeys." },
        { title: "Cloud Editions OT2", desc: "Cloud migration of critical ECM workloads." }
      ]}
    },
    roi: {
      fr: { title: "Retour sur investissement", items: [
        { value: "-70%", label: "Risque de non-conformité" },
        { value: "+50%", label: "Productivité knowledge workers" },
        { value: "€100K+", label: "Économies grandes entreprises/an" },
        { value: "99.99%", label: "SLA disponibilité" }
      ]},
      es: { title: "Retorno de inversión", items: [
        { value: "-70%", label: "Riesgo de incumplimiento" },
        { value: "+50%", label: "Productividad knowledge workers" },
        { value: "€100K+", label: "Ahorro grandes empresas/año" },
        { value: "99.99%", label: "SLA de disponibilidad" }
      ]},
      en: { title: "Return on investment", items: [
        { value: "-70%", label: "Compliance risk" },
        { value: "+50%", label: "Knowledge worker productivity" },
        { value: "€100K+", label: "Large enterprise savings/year" },
        { value: "99.99%", label: "Availability SLA" }
      ]}
    }
  },

  openkm: {
    id: "openkm", color: "#1B7B96",
    logo: "https://customer-assets.emergentagent.com/job_7fe777d6-9bad-4a97-9808-a97a60a006ea/artifacts/89huz0wr_logo%20openkm.jpg",
    website: "https://www.openkm.com/", youtube: "",
    country: { code: "ES", name: { fr: "Espagne", es: "España", en: "Spain" } },
    hero: {
      fr: { title: "OpenKM - GED open-core et Knowledge Management", subtitle: "Plateforme de gestion documentaire et knowledge management déployable Cloud, On-Premise ou Hybride. IA, workflows, records management, recherche intelligente.", cta: "Demander une démo" },
      es: { title: "OpenKM - DMS open-core y Knowledge Management", subtitle: "Plataforma de gestión documental y knowledge management desplegable en Cloud, On-Premise o Híbrido. IA, workflows, records management, búsqueda inteligente.", cta: "Solicitar demo" },
      en: { title: "OpenKM - Open-core DMS and Knowledge Management", subtitle: "Document management and knowledge management platform, Cloud, On-Premise or Hybrid. AI, workflows, records management, intelligent search.", cta: "Request a demo" }
    },
    benefits: {
      fr: { title: "Pourquoi choisir OpenKM ?", items: [
        { icon: "brain", title: "IA et recherche intelligente", desc: "OCR, classification automatique et recherche sémantique." },
        { icon: "workflow", title: "Workflows et BPM", desc: "Automatisation complète des processus documentaires." },
        { icon: "shield", title: "Records management", desc: "Conformité RGPD, ISO 15489, eIDAS, archivage légal." },
        { icon: "link", title: "API REST ouverte", desc: "Connecteurs Office, SAP, Sage, Odoo, et plus de 50 outils." },
        { icon: "globe", title: "Déploiement flexible", desc: "Cloud, On-Premise ou Hybride - choisissez votre modèle." },
        { icon: "users", title: "Open-core robuste", desc: "Code source ouvert, communauté active, présent dans +80 pays." }
      ]},
      es: { title: "¿Por qué elegir OpenKM?", items: [
        { icon: "brain", title: "IA y búsqueda inteligente", desc: "OCR, clasificación automática y búsqueda semántica." },
        { icon: "workflow", title: "Workflows y BPM", desc: "Automatización completa de procesos documentales." },
        { icon: "shield", title: "Records management", desc: "Cumplimiento RGPD, ISO 15489, eIDAS, archivado legal." },
        { icon: "link", title: "API REST abierta", desc: "Conectores Office, SAP, Sage, Odoo y más de 50 herramientas." },
        { icon: "globe", title: "Despliegue flexible", desc: "Cloud, On-Premise o Híbrido - elija su modelo." },
        { icon: "users", title: "Open-core robusto", desc: "Código abierto, comunidad activa, presente en +80 países." }
      ]},
      en: { title: "Why choose OpenKM?", items: [
        { icon: "brain", title: "AI & intelligent search", desc: "OCR, automatic classification and semantic search." },
        { icon: "workflow", title: "Workflows & BPM", desc: "Full automation of document processes." },
        { icon: "shield", title: "Records management", desc: "GDPR, ISO 15489, eIDAS compliance, legal archiving." },
        { icon: "link", title: "Open REST API", desc: "Office, SAP, Sage, Odoo connectors and 50+ tools." },
        { icon: "globe", title: "Flexible deployment", desc: "Cloud, On-Premise or Hybrid - your choice." },
        { icon: "users", title: "Robust open-core", desc: "Open source, active community, present in 80+ countries." }
      ]}
    },
    useCases: {
      fr: { title: "Cas d'usage", items: [
        { title: "Secteur public", desc: "Gestion documentaire conforme avec records management." },
        { title: "Juridique et conformité", desc: "Archivage à valeur probante et cycle de vie documentaire." },
        { title: "Éducation et recherche", desc: "Knowledge management et collaboration documentaire." }
      ]},
      es: { title: "Casos de uso", items: [
        { title: "Sector público", desc: "Gestión documental conforme con records management." },
        { title: "Jurídico y cumplimiento", desc: "Archivado con valor probatorio y ciclo de vida documental." },
        { title: "Educación e investigación", desc: "Knowledge management y colaboración documental." }
      ]},
      en: { title: "Use cases", items: [
        { title: "Public sector", desc: "Compliant document management with records management." },
        { title: "Legal & compliance", desc: "Legal-value archiving and document lifecycle." },
        { title: "Education & research", desc: "Knowledge management and document collaboration." }
      ]}
    },
    roi: {
      fr: { title: "Retour sur investissement", items: [
        { value: "-55%", label: "Coûts de licence vs. propriétaire" },
        { value: "+50%", label: "Productivité documentaire" },
        { value: "€25K", label: "Économies moyennes/an" },
        { value: "100%", label: "Souveraineté On-Premise" }
      ]},
      es: { title: "Retorno de inversión", items: [
        { value: "-55%", label: "Coste licencia vs. propietario" },
        { value: "+50%", label: "Productividad documental" },
        { value: "€25K", label: "Ahorro medio/año" },
        { value: "100%", label: "Soberanía On-Premise" }
      ]},
      en: { title: "Return on investment", items: [
        { value: "-55%", label: "License cost vs. proprietary" },
        { value: "+50%", label: "Document productivity" },
        { value: "€25K", label: "Average savings/year" },
        { value: "100%", label: "On-Premise sovereignty" }
      ]}
    }
  },

  "gnd-consulting": {
    id: "gnd-consulting",
    color: "#16A34A",
    logo: "https://customer-assets.emergentagent.com/job_7fe777d6-9bad-4a97-9808-a97a60a006ea/artifacts/zw7hup1s_GDNSolutions-60px.png",
    heroImage: "https://customer-assets.emergentagent.com/job_7fe777d6-9bad-4a97-9808-a97a60a006ea/artifacts/b6kwncsq_gnd2.0.jpg",
    videoTitleOverride: {
      fr: "Découvrez GND Solutions",
      es: "Descubra GND Solutions",
      en: "Discover GND Solutions"
    },
    website: "https://www.gnd-consulting.eu",
    youtube: "",
    country: { code: "FR", name: { fr: "France", es: "Francia", en: "France" } },
    hero: {
      fr: { title: "GND Consulting - GED & Digitalisation d'entreprise", subtitle: "Solutions complètes de gestion documentaire et transformation digitale pour les entreprises européennes.", cta: "Demander une démo" },
      es: { title: "GND Consulting - DMS y Digitalización empresarial", subtitle: "Soluciones completas de gestión documental y transformación digital para empresas europeas.", cta: "Solicitar demo" },
      en: { title: "GND Consulting - DMS & Enterprise Digitalization", subtitle: "Complete document management and digital transformation solutions for European businesses.", cta: "Request a demo" }
    },
    benefits: {
      fr: { title: "Pourquoi GND Consulting ?", items: [
        { icon: "layers", title: "Gestion documentaire", desc: "Centralisation et automatisation de tous vos documents métier." },
        { icon: "shield", title: "Conformité RGPD", desc: "Archivage légal et traçabilité complète des accès." },
        { icon: "link", title: "Intégrations ERP", desc: "Compatible SAP, Sage, Odoo et principaux outils." },
        { icon: "zap", title: "Automatisation IA", desc: "OCR intelligent et classification automatique." },
        { icon: "globe", title: "Cloud sécurisé", desc: "Infrastructure européenne, disponibilité 99.9%." },
        { icon: "coins", title: "ROI mesurable", desc: "-40% temps de recherche, -60% coûts papier." }
      ]},
      es: { title: "¿Por qué GND Consulting?", items: [
        { icon: "layers", title: "Gestión documental", desc: "Centralización y automatización de documentos." },
        { icon: "shield", title: "Cumplimiento RGPD", desc: "Archivo legal y trazabilidad completa." },
        { icon: "link", title: "Integraciones ERP", desc: "Compatible con SAP, Sage, Odoo." },
        { icon: "zap", title: "Automatización IA", desc: "OCR inteligente y clasificación automática." },
        { icon: "globe", title: "Cloud seguro", desc: "Infraestructura europea, 99.9% disponibilidad." },
        { icon: "coins", title: "ROI medible", desc: "-40% tiempo de búsqueda, -60% costos papel." }
      ]},
      en: { title: "Why GND Consulting?", items: [
        { icon: "layers", title: "Document management", desc: "Centralize and automate all business documents." },
        { icon: "shield", title: "GDPR compliance", desc: "Legal archiving and complete access traceability." },
        { icon: "link", title: "ERP integrations", desc: "Compatible with SAP, Sage, Odoo." },
        { icon: "zap", title: "AI automation", desc: "Smart OCR and automatic classification." },
        { icon: "globe", title: "Secure cloud", desc: "European infrastructure, 99.9% uptime." },
        { icon: "coins", title: "Measurable ROI", desc: "-40% search time, -60% paper costs." }
      ]}
    },
    useCases: {
      fr: { title: "Cas d'usage", items: [
        { title: "Dématérialisation", desc: "De la facture au contrat, tout est numérisé et classé." },
        { title: "Workflows métier", desc: "Automatisez vos processus de validation et signatures." },
        { title: "Conformité RGPD", desc: "Archivage légal et traçabilité complète." }
      ]},
      es: { title: "Casos de uso", items: [
        { title: "Digitalización", desc: "De la factura al contrato, todo digitalizado y clasificado." },
        { title: "Workflows empresariales", desc: "Automatice sus procesos de validación y firmas." },
        { title: "Cumplimiento RGPD", desc: "Archivo legal y trazabilidad completa." }
      ]},
      en: { title: "Use cases", items: [
        { title: "Digitization", desc: "From invoice to contract, everything is digitized and classified." },
        { title: "Business workflows", desc: "Automate your approval and signature processes." },
        { title: "GDPR compliance", desc: "Legal archiving and complete traceability." }
      ]}
    },
    roi: {
      fr: { title: "Impact mesuré", items: [
        { value: "-40%", label: "Temps de recherche" },
        { value: "-60%", label: "Coûts papier" },
        { value: "+80%", label: "Automatisation" },
        { value: "6 mois", label: "ROI moyen" }
      ]},
      es: { title: "Impacto medido", items: [
        { value: "-40%", label: "Tiempo de búsqueda" },
        { value: "-60%", label: "Costos papel" },
        { value: "+80%", label: "Automatización" },
        { value: "6 meses", label: "ROI medio" }
      ]},
      en: { title: "Measured impact", items: [
        { value: "-40%", label: "Search time" },
        { value: "-60%", label: "Paper costs" },
        { value: "+80%", label: "Automation" },
        { value: "6 months", label: "Average ROI" }
      ]}
    }
  }
};

// Common labels for landing pages
export const landingLabels = {
  fr: {
    videoTitle: "Découvrez la solution en vidéo",
    formTitle: "Demander une démo personnalisée",
    formSubtitle: "Remplissez le formulaire et notre équipe vous contactera sous 24h.",
    formName: "Nom complet",
    formEmail: "Email professionnel",
    formPhone: "Téléphone",
    formCompany: "Entreprise",
    formMessage: "Message (optionnel)",
    formSubmit: "Envoyer ma demande",
    formSuccess: "Demande envoyée avec succès !",
    ctaBottom: "Comparer toutes les solutions GED",
    ctaBottomSub: "Utilisez notre comparateur IA pour trouver la solution idéale pour votre entreprise.",
    ctaBottomBtn: "Lancer le comparateur",
    backHome: "Retour à l'accueil"
  },
  es: {
    videoTitle: "Descubra la solución en vídeo",
    formTitle: "Solicitar una demo personalizada",
    formSubtitle: "Complete el formulario y nuestro equipo le contactará en 24h.",
    formName: "Nombre completo",
    formEmail: "Email profesional",
    formPhone: "Teléfono",
    formCompany: "Empresa",
    formMessage: "Mensaje (opcional)",
    formSubmit: "Enviar mi solicitud",
    formSuccess: "Solicitud enviada con éxito!",
    ctaBottom: "Comparar todas las soluciones DMS",
    ctaBottomSub: "Use nuestro comparador IA para encontrar la solución ideal para su empresa.",
    ctaBottomBtn: "Iniciar el comparador",
    backHome: "Volver al inicio"
  },
  en: {
    videoTitle: "Discover the solution in video",
    formTitle: "Request a personalized demo",
    formSubtitle: "Fill the form and our team will contact you within 24h.",
    formName: "Full name",
    formEmail: "Professional email",
    formPhone: "Phone",
    formCompany: "Company",
    formMessage: "Message (optional)",
    formSubmit: "Send my request",
    formSuccess: "Request sent successfully!",
    ctaBottom: "Compare all DMS solutions",
    ctaBottomSub: "Use our AI comparator to find the ideal solution for your business.",
    ctaBottomBtn: "Launch the comparator",
    backHome: "Back to home"
  }
};
